module.exports = __webpack_public_path__ + "static/img/help_05_02.2d0d52e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_05_02.png
// module id = 693
// module chunks = 140